<template>
  <div class="master-container">
    <div
      class="master-box"
      v-for="(Nav, index) in SideNav[5].children"
      :key="index"
      v-if="Nav.name != 'Role Management Master'"
    >
      <router-link :to="Nav.url">
        <div>
          <h4>{{ $tc(Nav.name, 2) }}</h4>
          <p>{{ $t(Nav.description) }}</p>
        </div>
        <div>
          <img src="@/assets/img/icons/arrow-right.svg" width="20" height="20" alt>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Nav from "@/Nav";
export default {
  data() {
    return {
      SideNav: Nav.items
    };
  }
};
</script>

 


// WEBPACK FOOTER //
// src/components/Pages/RoleManagementContainer/roleManagementMaster.vue